import { DeckType } from '../../domain/entities/Room';
import { isTShirtSize } from '../../domain/valueObjects/TShirtDeck';
import { T } from './translations';

/**
 * Maps a canonical card value (Fibonacci string or t-shirt size code) to the
 * label shown in the viewer's language. `?` and `☕` are unchanged.
 */
export function getCardLabel(card: string, deckType: DeckType, t: T): string {
  if (deckType === 'tshirt' && isTShirtSize(card)) {
    return t.tshirtCard[card];
  }
  return card;
}
